import React from 'react'
import { withStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

import Navigation from 'components/shared/Navigation'
import Title from 'components/shared/Navigation/Title'
import ScrollToTopOnMount from 'components/shared/ScrollToTopOnMount'

/* istanbul ignore next */
const styles = theme => ({
  main: {
    width: '100%',
    flex: 1,
  }
})

interface IProps {
  classes: any
  children: any
  title?: string
  userName?: string
}

export const Page = ({ classes, children, title }: IProps) => (
  <Grid container direction="column">
    <Title title={title} />
    <ScrollToTopOnMount />
    <Navigation />
    <Grid item className={classes.main}>
      <Box mx={{ xs: 1, sm: 3, md: 5, xl: 10 }} mt={{ xs: 2, md: 6 }} mb={{ xs: 2, md: 4 }}>
        {children}
      </Box>
    </Grid>
  </Grid>
)

export default withStyles(styles)(Page)
